import React, { useState } from 'react';
import BuildingLookupModal from './BuildingLookupModal';

/**
 * Row 1: A single row with:
 *  [ read‐only input (showing buildingId) ] [ "Select Building" button => opens modal ]
 *
 * Receives:
 *   - buildingId (string)
 *   - onBuildingChange(bId, aId) => to update parent's state
 */
const BuildingLookupForm = ({ buildingId, onBuildingChange }) => {
  const [modalOpen, setModalOpen] = useState(false);

  // Called by BuildingLookupModal when user picks a building
  const handleSelectBuilding = (bId, aId) => {
    onBuildingChange(bId, aId);
    setModalOpen(false);
  };

  return (
    <div className="flex items-center space-x-4 w-full">
      <input
        type="text"
        readOnly
        className="border border-gray-300 p-1 rounded-md bg-gray-100 text-gray-700 flex-1"
        value={buildingId || 'No building selected yet'}
      />

      <span className="font-semibold whitespace-nowrap">Building Lookup</span>

      <button
        onClick={() => setModalOpen(true)}
        className="px-3 py-1 bg-blue-600 text-white rounded hover:bg-blue-700 whitespace-nowrap"
      >
        Select Building
      </button>

      {/* The modal => now separate, but imported */}
      <BuildingLookupModal
        open={modalOpen}
        onClose={() => setModalOpen(false)}
        onSelect={handleSelectBuilding}
      />
    </div>
  );
};

export default BuildingLookupForm;
